import { obterNomeCacheRequerimentoTO } from "./helper";

const regexCaracteresIndesejados = /([._-])/g;

let requerimentoTO = JSON.parse(localStorage.getItem(obterNomeCacheRequerimentoTO()));

let requerimentoTOInicial = {
  contato: {
    concluido: false,
    email: '',
    aceitaNotificacao: '',
    aceitaAcompanhar: '',
    whatsappTO: {
      ddi: '55',
      numero: ''
    },
    celularTO: {
      ddi: '55',
      numero: ''
    },
    telResidencialTO: {
      ddi: '55',
      numero: ''
    }
  },
  dadosPedido: {},
  dadosAdicionais: [],
  anexos: [],
  vinculos: []
}

const INITIAL_STATE = (requerimentoTO?.etapas?.contato && (requerimentoTO.etapas.contato.concluido || requerimentoTO.etapas.contato.iniciado)) ?
  ({ requerimentoTO }) : ({ requerimentoTO: JSON.parse(JSON.stringify(requerimentoTOInicial)) });


const setValueByPath = (state, path, value, campoId) => {
  const pathParts = path.split('.');
  let currentState = { ...state };

  for (let i = 0; i < pathParts.length - 1; i++) {
    currentState = currentState[pathParts[i]];
  }

  const lastPart = pathParts[pathParts.length - 1];
  if (lastPart === 'dadosAdicionais') {
    const campoAdicionalIndex = currentState[lastPart].findIndex((campo) => campo.id === campoId);
    if (campoAdicionalIndex !== -1) {
      currentState[lastPart] = currentState[lastPart].map((campo, index) =>
        index === campoAdicionalIndex
          ? atualizarCampoAdicional(campo, value)
          : campo
      );
    }
  } else {
    currentState[lastPart] = value;
  }

  return { ...state };
};

const atualizarCampoAdicional = (campo, value) => {
  const valorModificado = campo.mascara ? value.replace(regexCaracteresIndesejados, "") : value;
  return {
    ...campo,
    valorComMascara: value,
    valor: valorModificado
  };
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case 'REQUERIMENTO_ONBOARDING_INICIAR':
      return { ...state, loadingTarefas: true }
    case 'REQUERIMENTO_ONBOARDING_INICIAR_ETAPA': {
      const etapa = action.payload;
      const requerimentoTO = { ...state.requerimentoTO };
      if (requerimentoTO.etapas && Object.prototype.hasOwnProperty.call(requerimentoTO.etapas, etapa)) {
        const novosAtributos = { ...requerimentoTO.etapas, [etapa]: {...requerimentoTO.etapas[etapa], concluido: false, iniciado: true } };
        if (etapa !== 'resumo' && novosAtributos?.['disponibilidade']) {
          novosAtributos.disponibilidade = { ...novosAtributos.disponibilidade, concluido: false }
        }
        
        let requerimentoCache = JSON.parse(localStorage.getItem(obterNomeCacheRequerimentoTO()));
        if (requerimentoCache && requerimentoCache.etapas && novosAtributos) {
          const novoRequerimentoCache = { ...requerimentoCache, etapas: novosAtributos }
          localStorage.setItem(obterNomeCacheRequerimentoTO(), JSON.stringify(novoRequerimentoCache));
        }

        return { ...state, requerimentoTO: { ...requerimentoTO, etapas: novosAtributos } };
      }
      return state;
    }
    case 'REQUERIMENTO_ONBOARDING_CONCLUIR_ETAPA': {
      const { etapa, concluido } = action.payload;
      const requerimentoTO = { ...state.requerimentoTO };
      if (requerimentoTO.etapas && Object.prototype.hasOwnProperty.call(requerimentoTO.etapas, etapa)) {
        requerimentoTO.etapas[etapa].concluido = concluido;
      }

      localStorage.setItem(obterNomeCacheRequerimentoTO(), JSON.stringify(requerimentoTO));
      return { ...state, requerimentoTO, conteudosAnexos: [] };
    }
    case 'REQUERIMENTO_SET_REQUERIMENTO_INIT': {
      const requerimento = action.payload;
      if (state?.requerimentoTO?.vinculos) {
        requerimento.vinculos = state.requerimentoTO.vinculos;
      }
      if (state?.requerimentoTO?.disponibilidade) {
        requerimento.disponibilidade = state.requerimentoTO.disponibilidade;
      }
      if (state?.requerimentoTO?.orgaoPagador) {
        requerimento.orgaoPagador = state.requerimentoTO.orgaoPagador;
      }
      if (state?.requerimentoTO?.etapas) {
        requerimento.etapas = state.requerimentoTO.etapas;
      }
      return { ...state, requerimentoTO: requerimento }
    }
    case 'REQUERIMENTO_SET_REQUERIMENTO_ZERAR': {
      localStorage.removeItem(obterNomeCacheRequerimentoTO());
      return { ...state, previewPage: null, requerimentoTO: JSON.parse(JSON.stringify(requerimentoTOInicial)) }
    }
    case 'REQUERIMENTO_SET_REQUERIMENTO_TO': {
      const { path, value } = action.payload;
      return setValueByPath(state, path, value);
    }
    case 'REQUERIMENTO_ALTERAR_CAMPO_ADICIONAL': {
      const { path, value, campoId } = action.payload;
      return setValueByPath(state, path, value, campoId);
    }
    case "REQUERIMENTO_ALTERAR_LISTA_CAMPO_ADICIONAL": {
      return {
        ...state,
        requerimentoTO: {
          ...state.requerimentoTO,
          dadosAdicionais: action.payload,
        },
      };
    }
    case 'REQUERIMENTO_ONBOARDING_PREVIEW_PAGE':
      return { ...state, previewPage: action.payload }
    case 'REQUERIMENTO_ALTERAR_LISTA_ANEXOS': {
      return {
        ...state,
        requerimentoTO: {
          ...state.requerimentoTO,
          anexos: [...action.payload],
        },
      };
    }
    case 'REQUERIMENTO_ALTERAR_LISTA_VINCULOS': {
      return {
        ...state,
        requerimentoTO: {
          ...state.requerimentoTO,
          vinculos: action.payload,
        },
      };
    }
    case 'REQUERIMENTO_ADICIONAR_VINCULO': {
      return {
        ...state,
        requerimentoTO: {
          ...state.requerimentoTO,
          vinculos: [...state.requerimentoTO.vinculos, action.payload],
        },
      };
    }
    case 'REQUERIMENTO_ANEXOS_ENVIAR_ARQUIVO_SUCESSO': {
      const requerimento = action.payload.requerimento;
      let conteudosAnexos = state.conteudosAnexos
      if (!conteudosAnexos) {
        conteudosAnexos = [];
      }
      if (state?.requerimentoTO?.vinculos) {
        requerimento.vinculos = state.requerimentoTO.vinculos;
      }
      if (state?.requerimentoTO?.disponibilidade) {
        requerimento.disponibilidade = state.requerimentoTO.disponibilidade;
      }
      if (state?.requerimentoTO?.orgaoPagador) {
        requerimento.orgaoPagador = state.requerimentoTO.orgaoPagador;
      }
      if (state?.requerimentoTO?.etapas) {
        requerimento.etapas = state.requerimentoTO.etapas;
      }
      if (action.payload.conteudosAnexos?.length) {
        const novosAnexos = action.payload.conteudosAnexos.filter(c => !conteudosAnexos.some(c2 => c2.idConteudoAnexo === c.idConteudoAnexo))
        conteudosAnexos = conteudosAnexos.concat(novosAnexos);
      }
      return { ...state, requerimentoTO: requerimento, conteudosAnexos }
    }
    default:
      return state;
  }
}
